import React from 'react'

export default function UserMusic({ className }) {
  return (
    <svg viewBox="0 0 64 64" className={className}>
      <path
        d="M39.9 40.4A15.3 15.3 0 0046 28c0-8.3-6.3-15-14-15s-14 6.7-14 15a15.3 15.3 0 006.1 12.4A24.1 24.1 0 008 63h48a24.1 24.1 0 00-16.1-22.6z"
        fill="currentColor"
      />
      <path
        d="M52 19h-2a18 18 0 10-36 0h-2a4 4 0 00-4 4v10a4 4 0 004 4h4.2a19.8 19.8 0 01-2.2-9 19.5 19.5 0 014.5-12.5 14 14 0 0127.1 0A19.5 19.5 0 0150 28a19.8 19.8 0 01-2.2 9H52a4 4 0 004-4V23a4 4 0 00-4-4z"
        fill="currentColor"
      />
    </svg>
  )
}
